<template>
  <v-row>
    <v-col cols="12">
      <v-tooltip
        :model-value="tooltip.password"
        :open-delay="10000000"
        :close-delay="10000000"
        :max-width="$vuetify.display.mdAndUp ? '186' : '162'"
        location="right"
        color="primary"
        :disabled="!showToolTip || $vuetify.display.xs"
      >
        <template v-slot:activator>
          <onex-password
            :label="$t(passwordLabel)"
            required
            confirm
            :confirmLabel="$t(confirmPasswordLabel)"
            v-model="password"
            :data-comp-id="newPassId"
            @update:modelValue="onInput"
          />
        </template>
        <span role="tooltip" id="password-tooltip">
          {{ $t('L_password_tooltip') }}
        </span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { PasswordInput, ConfirmPasswordInput } from '@/components/Inputs';
import { notContainString, getErrorMessages } from '@/components/Inputs/validation';
import PasswordComplexity from './components/PasswordComplexity/PasswordComplexity.vue';
import { useVuelidate } from '@vuelidate/core';
import { OnexPassword } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'PasswordForm',
  props: {
    newPassId: {
      type: String,
      default: '',
    },
    confirmPassId: {
      type: String,
      required: true,
      default: '',
    },
    value: {
      type: [String],
      required: false,
      default: undefined,
    },
    email: {
      type: String,
      required: false,
      default: '',
    },
    passwordLabel: {
      type: String,
      required: false,
      default: 'L_password',
    },
    confirmPasswordLabel: {
      type: String,
      required: false,
      default: 'L_confirm_password',
    },
    showToolTip: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    password: '',
    tooltip: {
      password: false,
    } as { [key: string]: unknown },
    modelName: 'passwordForm',
    v$: useVuelidate(),
  }),
  validations() {
    return {
      password: {
        notContainString: (value: string, vm: { email: string }) => {
          if (vm.email.length === 0) {
            return true;
          }
          const valid = notContainString(value, vm.email);
          return valid;
        },
      },
    };
  },
  computed: {
    passwordErrors() {
      return getErrorMessages({
        vObject: this.v$,
        field: 'password',
      });
    },
  },
  methods: {
    onInput() {
      this.$emit('update:modelValue', this.v$.password.$invalid ? '' : this.password);
    },
    toggleTooltip({ field, show }: { field: string; show: boolean }) {
      this.tooltip[field] = show;
    },
    onMessage(message: { data: string }) {
      if (message.data === 'form-reset') {
        this.v$.$reset();
      }
    },
  },
  components: {
    PasswordComplexity,
    PasswordInput,
    ConfirmPasswordInput,
    OnexPassword,
  },
  watch: {
    value(value) {
      if (typeof value === 'undefined') {
        this.password = '';
      }
    },
  },
  mounted() {
    window.addEventListener('message', this.onMessage.bind(this));
  },
};

export default defineComponent(componentOptions);
</script>
